import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../api/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // 🔍 verifica sessão ao iniciar o app
  useEffect(() => {
    carregarUsuario();
  }, []);

  const carregarUsuario = async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch (error) {
      setUser(null);
      // Não precisa dar alert nem nada aqui, o 401 é normal se ele nunca logou
    } finally {
      setLoading(false);
    }
  };

  // 🔐 login (cookie httpOnly no backend)
  const login = async (email, senha) => {
  try {
    await api.post("/auth/login", { email, senha }, {
      withCredentials: true
    });

    // pequena garantia de persistência do cookie
    await new Promise(resolve => setTimeout(resolve, 100));

    await carregarUsuario();
  } catch (error) {
    setUser(null);
    throw error;
  }
};

  // 🚪 logout
  const logout = async () => {
  try {
    await api.post(
      "/auth/logout",
      {},
      { withCredentials: true }
    );
  } finally {
    setUser(null);
  }
};

  // 🧠 estado derivado
  const isAuthenticated = !!user;

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        login,
        logout,
        isAuthenticated
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);